$(document).on("click", ".taksit-bnr--close--container", () => {
  Cookies.set("suppress_taksit_banner", "true", {
    expires: 7,
  })
  $(".taksit-bnr").remove()
})
